/**
 * @jsxRuntime classic
 * @jsx jsx
 */

import { cssMap, jsx } from '@atlaskit/css';
import { Anchor } from '@atlaskit/primitives/compiled';
import { HoverCard } from '@atlaskit/smart-card/hover-card';

import { onJiraIssueKeyClicked } from '../../../../../ai-answer-dialog/analytics';
import type { NonGenerativeAIAnswerResultShownProps } from '../../../../../ai-answer-dialog/types';
import { useAnalytics } from '../../../../../common/controller/analytics/use-analytics';

const styles = cssMap({
	noWrap: {
		whiteSpace: 'nowrap',
	},
});

export const IssueKeyNode = ({
	issuekey,
	url,
	analyticsAttributes,
}: {
	issuekey: string;
	url: string;
	analyticsAttributes: NonGenerativeAIAnswerResultShownProps;
}) => {
	const [fireAnalyticsEvent] = useAnalytics();

	return (
		<HoverCard url={url}>
			<Anchor
				href={url}
				xcss={styles.noWrap}
				onClick={() =>
					fireAnalyticsEvent(onJiraIssueKeyClicked({ ...analyticsAttributes, issuekey }))
				}
			>
				{issuekey}
			</Anchor>
		</HoverCard>
	);
};
